/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerStatus } from './PamPlayerStatus';
import {
    PamPlayerStatusFromJSON,
    PamPlayerStatusFromJSONTyped,
    PamPlayerStatusToJSON,
} from './PamPlayerStatus';

/**
 * The player's PAM account status surfaced on the player-details screen, whether or not they
 * started KYC. Null/absent when the player has no PAM account.
 * @export
 * @interface PamPlayerAccountSummary
 */
export interface PamPlayerAccountSummary {
    /**
     * ISO-8601 timestamp of the status transition.
     * @type {Date}
     * @memberof PamPlayerAccountSummary
     */
    statusChangedAt: Date;
    /**
     * 
     * @type {PamPlayerStatus}
     * @memberof PamPlayerAccountSummary
     */
    status: PamPlayerStatus;
    /**
     * Why the status last changed, as recorded by staff or the system.
     * @type {string}
     * @memberof PamPlayerAccountSummary
     */
    statusReason: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PamPlayerAccountSummary
     */
    pamPlayerId: string;
}



/**
 * Check if a given object implements the PamPlayerAccountSummary interface.
 */
export function instanceOfPamPlayerAccountSummary(value: object): value is PamPlayerAccountSummary {
    if (!('statusChangedAt' in value) || value['statusChangedAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusReason' in value) || value['statusReason'] === undefined) return false;
    if (!('pamPlayerId' in value) || value['pamPlayerId'] === undefined) return false;
    return true;
}

export function PamPlayerAccountSummaryFromJSON(json: any): PamPlayerAccountSummary {
    return PamPlayerAccountSummaryFromJSONTyped(json, false);
}

export function PamPlayerAccountSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamPlayerAccountSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'statusChangedAt': (new Date(json['statusChangedAt'])),
        'status': PamPlayerStatusFromJSON(json['status']),
        'statusReason': json['statusReason'],
        'pamPlayerId': json['pamPlayerId'],
    };
}

export function PamPlayerAccountSummaryToJSON(value?: PamPlayerAccountSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statusChangedAt': ((value['statusChangedAt']).toISOString()),
        'status': PamPlayerStatusToJSON(value['status']),
        'statusReason': value['statusReason'],
        'pamPlayerId': value['pamPlayerId'],
    };
}

